import apiClient from './apiClient';

export const changeDirectorPassword = async (currentPassword, newPassword) => {
    try {
        const response = await apiClient.post(
            '/change_password.php',
            { currentPassword, newPassword },
            { headers: { 'Content-Type': 'application/json' } }
        );

        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            return error.response.data;
        }
        console.error('Errore nella richiesta changeDirectorPassword:', error);
        throw error;
    }
};

export default changeDirectorPassword;
